var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "m13.462 1.412 2.81 6.755a1.5 1.5 0 0 0 1.264.92l7.293.584a.5.5 0 0 1 .286.878l-5.557 4.76a1.5 1.5 0 0 0-.483 1.487l1.698 7.117a.5.5 0 0 1-.747.542l-6.244-3.813a1.5 1.5 0 0 0-1.564 0l-6.244 3.813a.5.5 0 0 1-.747-.542l1.698-7.117a1.5 1.5 0 0 0-.483-1.487l-5.557-4.76a.5.5 0 0 1 .286-.878l7.293-.585a1.5 1.5 0 0 0 1.265-.919l2.81-6.755a.5.5 0 0 1 .923 0Z"
  })));
};
export default SvgStar;